var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "col-sm-3 left-col-text wow fadeInRight" }, [
    _c(
      "div",
      { staticClass: "list-group" },
      [
        _vm.isInfoCategory || _vm.isNotCategory
          ? _c(
              "router-link",
              {
                staticClass: "list-group-item",
                class: { active: _vm.checkMatchCategory("info-all") },
                attrs: {
                  to: { path: "/posts/", query: { category: "info-all" } },
                },
              },
              [_vm._v("お知らせ一覧")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isActivityCategory || _vm.isNotCategory
          ? _c(
              "a",
              {
                staticClass: "list-group-item",
                attrs: { href: "/pages/?id=activity" },
              },
              [_vm._v("組合員活動とは")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isActivityCategory || _vm.isNotCategory
          ? _c(
              "router-link",
              {
                staticClass: "list-group-item",
                class: { active: _vm.checkMatchCategory("activity") },
                attrs: {
                  to: { path: "/posts/", query: { category: "activity" } },
                },
              },
              [_vm._v("組合員活動一覧")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isActivityCategory || _vm.isNotCategory
          ? _c(
              "router-link",
              {
                staticClass: "list-group-item",
                class: { active: _vm.checkMatchCategory("entry") },
                attrs: {
                  to: { path: "/posts/", query: { category: "entry" } },
                },
              },
              [_vm._v("参加募集一覧")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isActivityCategory || _vm.isNotCategory
          ? _c(
              "router-link",
              {
                staticClass: "list-group-item",
                class: { active: _vm.checkMatchCategory("report") },
                attrs: {
                  to: { path: "/posts/", query: { category: "report" } },
                },
              },
              [_vm._v("活動レポート一覧")]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("a", { staticClass: "list-group-item", attrs: { href: "/news/" } }, [
          _vm._v("過去のニュース一覧"),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }